module.exports = __webpack_public_path__ + "static/clinic-door-b13de31d7bf527615257151baa2804f3.webp";